"use client";

import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const LOCALSTORAGE_KEY = "esimPromoDismissedUntil";

export default function ESimPromoModal({ cooldownDays = 1, hideOnPaths = [] }) {
  const [visible, setVisible] = useState(false);
  const pathname = usePathname();
  const suppressed = hideOnPaths.includes(pathname);

  useEffect(() => {
    if (suppressed) return;

    const dismissedUntil =
      parseInt(localStorage.getItem(LOCALSTORAGE_KEY), 10) || 0;

    if (Date.now() > dismissedUntil) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, [suppressed]);

  const dismiss = () => {
    const hideUntil = Date.now() + cooldownDays * 24 * 60 * 60 * 1000;
    localStorage.setItem(LOCALSTORAGE_KEY, hideUntil.toString());
    setVisible(false);
  };

  if (suppressed || !visible) return null; // IMPORTANT

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 px-4"
      onClick={(e) => e.target === e.currentTarget && dismiss()}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="relative w-full max-w-md rounded-2xl bg-surface shadow-2xl text-textPrimary animate-fadeIn overflow-hidden"
      >
        <button
          onClick={dismiss}
          className="absolute top-3 right-3 text-textSecondary text-2xl hover:text-white transition"
          aria-label="Close"
        >
          ×
        </button>

        <div className="p-6 text-center">
        <div className="text-2xl font-semibold text-white">
            Digital Products. Global Reach.
          </div>

          <p className="text-xl font-semibold mt-2">
            300+ payment methods supported.
          </p>

          <p className="text-textSecondary mt-3 text-base leading-relaxed">
            50,000+ products available instantly in 190+ countries.
          </p>

          <p className="text-textSecondary mt-2 text-base leading-relaxed">
            5 months of continuous growth and 3,500+ customers served worldwide.
          </p>

          <div className="my-5 h-px w-full bg-white/10" />

          <p className="text-sm text-textSecondary">
            Fast delivery. Secure checkout. Reliable support.
          </p>
        </div>
      </div>
    </div>
  );
}